



















































import { Vue, Component } from 'vue-property-decorator';
import PartnerLogoBelt from '@/components/homePage/PartnerLogoBelt.vue';

@Component({ components: { PartnerLogoBelt } })
export default class HomePageFR extends Vue {}
